import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import tokenReducer from './token/tokenReducer';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['accessToken'],
};

const persistedReducer = persistReducer(persistConfig, tokenReducer);

// eslint-disable-next-line
export const store = createStore(persistedReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export const persistor = persistStore(store);

